<template>
	<div class="ui buttons" :class="{hide: validAccounts.length === 0}">
		<div class="ui large icon dropdown button switch-account-button">
			<i class="user icon" />

			<div class="menu">
				<template v-if="currentAccount">
					<div class="header dropdown-header">
						<div class="main-header">Current Account</div>
					</div>

					<div class="item account-option current-account-item" id="current-account-item">
						<div class="ui small header">
							<div class="ui large avatar image" v-if="currentAccount.organization.parent_organization?.logo_thumb_url"><img :src="currentAccount.organization.parent_organization.logo_thumb_url" /></div>
							<div class="ui large avatar image" v-else-if="currentAccount.organization.logo_thumb_url"><img :src="currentAccount.organization.logo_thumb_url" /></div>
							<div class="content">
								{{ currentAccount.organization.name }}

								<div class="sub header" v-if="currentAccount.organization.parent_organization">{{ currentAccount.organization.parent_organization.name }}</div>
							</div>
						</div>
					</div>

					<div class="divider" />
				</template>
				<div class="item account-option" v-for="account in validAccounts" :key="account.id" :data-value="account.id">
					<div class="ui small header">
						<div class="ui large avatar image" v-if="account.organization.parent_organization?.logo_thumb_url"><img :src="account.organization.parent_organization.logo_thumb_url" /></div>
						<div class="ui large avatar image" v-else-if="account.organization.logo_thumb_url"><img :src="account.organization.logo_thumb_url" /></div>
						<div class="content">
							{{ account.organization.name }}

							<div class="sub header" v-if="account.organization.parent_organization">{{ account.organization.parent_organization.name }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['accounts', 'plicSlug'],
	computed: {
		currentAccount() {
			return this.accounts.find(account => account.currentAccount);
		},
		validAccounts() {
			// Filter out accounts that the user can't see
			let accounts = this.accounts.filter(account => account.enable_plic_app_whitelist === false || account.plic_app_whitelist_slugs.includes(this.plicSlug));
			// Filter out currently selected account
			accounts = accounts.filter(account => !account.currentAccount);

			accounts.sort((a, b) => a.organization.name.toLowerCase().localeCompare(b.organization.name.toLowerCase()));

			return accounts;
		}
	},
	mounted() {
		// For tests
		if(!$.fn.dropdown) {
			return;
		}
		$(this.$el).children('.ui.dropdown').dropdown({
			onChange: (value) => {
				let account = this.accounts.find(account => account.id === value);
				if(!account) {
					return;
				}

				$.Confirm('Switch Account', 'Are you sure you want to switch to ' + account.organization.name, () => {
					this.$emit('startLoading');

					$.ajax({
						url: 'ajax/switchAccount.php',
						type: 'post',
						data: {
							accountId: account.id
						},
						success: () => {
							window.location = '/';
						},
						error: (xhr) => {
							this.$emit('stopLoading');

							let errorMessage = 'Failed to switch accounts';
							if(xhr?.responseJSON?.reason) {
								errorMessage += ': ' + xhr.responseJSON.reason;
							}
							$.Alert('Error', errorMessage);
						}
					});
				});
			}
		});
	}
};
</script>

<style scoped>
.hide {
	display: none;
}

.main-header {
	font-size: 1rem;
}

.dropdown-header-content {
	display: flex;
	font-size: 1.07142857em;
}
.dropdown-header-content .ui.avatar.image {
	width: 2.5em;
	margin-right: 0.25em;
}

#current-account-item {
	cursor: initial;
	pointer-events: none;

	padding-top: 0 !important;
	padding-bottom: 0 !important;
}

.ui.buttons .ui.dropdown .menu {
	font-size: 1.21428571rem;
}
</style>